import { Injectable } from "@angular/core";
import { BigNumber, RoundToMillionsType, TradingGroupImpl } from "shared/cubiq-model-multi-asset";
import { BehaviorSubject, Observable } from "rxjs";
import { BfxBlotterFilterBarData } from "../../bfx-blotter-filter/bfx-blotter-filter-bar.constants";

@Injectable()
export class BfxHedgeOrderMonitorUtilService {
  private bfxHomComponent: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private blotterBarSync: BehaviorSubject<BfxBlotterFilterBarData> =
    new BehaviorSubject<BfxBlotterFilterBarData>(null);

  public hedgeOrderMonitorComponent$: Observable<any> = this.bfxHomComponent.asObservable();
  public blotterBarSync$: Observable<BfxBlotterFilterBarData> = this.blotterBarSync.asObservable();

  public setHedgeOrderMonitorComponent(homUtilObject: any) {
    this.bfxHomComponent.next(homUtilObject);
  }

  public syncBlotterFilterBar(data: BfxBlotterFilterBarData) {
    this.blotterBarSync.next(data);
  }

  /**
   * Round the amount to millions based on the trader group setting. The method will always return a positive value.
   * @param amount the amount to be rounded
   * @param traderGroup the trader group the rounding is done for
   * @returns the rounded up sum if rounding is not disabled
   */
  public roundToMillion(
    amount: string | number | BigNumber,
    traderGroup: TradingGroupImpl,
  ): BigNumber {
    return traderGroup != null
      ? this.roundToMillionType(amount, traderGroup.roundToMillionsType)
      : null;
  }

  /**
   * Round the amount to millions based on a given rounding type. The method will always return a positive value.
   * @param amount the amount to be rounded
   * @param roundToMillionsType the trader group the rounding is done for
   * @returns the rounded up sum if rounding is not disabled
   */
  public roundToMillionType(
    amount: string | number | BigNumber,
    roundToMillionsType: RoundToMillionsType,
  ): BigNumber {
    let value: BigNumber = null;

    if (amount != null) {
      value = new BigNumber(amount).absoluteValue();

      if (roundToMillionsType == RoundToMillionsType.ROUND) {
        value = value
          .absoluteValue()
          .div(1000000)
          .decimalPlaces(0, BigNumber.ROUND_HALF_UP)
          .times(1000000);
      } else if (roundToMillionsType == RoundToMillionsType.ROUNDDOWN) {
        value = value
          .absoluteValue()
          .div(1000000)
          .decimalPlaces(0, BigNumber.ROUND_DOWN)
          .times(1000000);
      }
    }

    return value;
  }
}
